import React from 'react';

import {CommonInputInterface} from '../common-input-interface';
import {Field} from '../field';
import {cls} from '../../../utils';
import {Checkmark} from './checkmark';

import css from './checkbox.module.css';

interface Props extends CommonInputInterface<boolean> {
	/* выбрана часть: вместо галочки черта */
	indeterminate?: boolean;
}

export type CheckboxProps = Omit<
	Omit<React.InputHTMLAttributes<HTMLInputElement>, keyof Props> & Props,
	'appearance' | 'size' | 'shape' | 'value'
>;

export const Checkbox: React.FC<CheckboxProps> = (props) => {
	const {label, checked, indeterminate, className, onChange} = props;

	function handleChange(event: React.MouseEvent) {
		event.stopPropagation();
		if (onChange && !props.disabled) onChange(!checked);
	}

	return (
		<Field className={className} commonProps={{...props, label: null}}>
			<div
				className={cls(css.wrapper, props.disabled && css.disabled)}
				onClick={handleChange}
				role="checkbox"
				aria-checked={indeterminate ? 'mixed' : checked ? 'true' : 'false'}
				aria-label={props['aria-label']}
				tabIndex={0}
			>
				<Checkmark checked={checked} indeterminate={indeterminate} disabled={props.disabled} />
				{label && <span className={css.label}>{label}</span>}
			</div>
		</Field>
	);
};
